import CurrentUser from "../current-user";
import {CompanyRole} from "../../../gd/const/company-role";
import UserManager from "../../../manager/user-manager/user-manager";


export class CurrentUserAccess {

    private user : CurrentUser

    constructor(currentUser:CurrentUser) {
        this.user = currentUser
    }

    hasManagerAccessToUser(userId:ID):boolean {

        // Manager access
        const userManager = new UserManager();
        return userManager.isManagerForUser(userId)

    }

    //
    get canCreateViewTemplates():boolean {
        return this.isCompanyUser
    }

    get canCreateRootProject():boolean {
        switch (gd.company.role) {
            case CompanyRole.MANAGER:
                return true
            case CompanyRole.USER:
                return gd.company.settings.companyRole.user.createRootProject
            default:
                return false
        }
    }

    get isAdmin():boolean {
        return gd.company && gd.company.isAdmin
    }

    get isManager():boolean {
        return gd.company && gd.company.role === gd.const.companyRole.MANAGER
    }

    get isClient():boolean {
        return gd.company && gd.company.role === CompanyRole.CLIENT
    }

    get isGuest():boolean {
        return gd.company && gd.company.role === CompanyRole.GUEST
    }

    get canAdvancedSearch():boolean {
        return !this.isClient // && !this.isGuest
    }

    get canAccessProjects():boolean {
        if (this.isClient) return false
        return true
    }


    // HELPER FUNCTION

    get isCompanyUser():boolean {

        const companyUser = gd.session.companyUsers.findByCompanyAndUser(gd.companyId, this.user.id)
        if (companyUser && companyUser.companyRole >= gd.const.companyRole.USER ) {
            return true
        }

        return false

    }




}

